import { useState, useEffect, useRef } from "react";

const PHRASES = ["Test"];

const TYPING_SPEED = 45;
const TYPING_JITTER = 30;
const PHRASE_DURATION = 3000; //après frappe terminée
const RESTART_DELAY = 4500;
const TRANSITION_DURATION = 500; //durée animation de sortie (glissement haut + fondu)

export default function AIThinking({ phrases = PHRASES, loop = true }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [displayed, setDisplayed] = useState("");
  const [status, setStatus] = useState("entering"); // "entering" | "idle" | "exiting"
  const [progress, setProgress] = useState(0);

  const typingRef = useRef(null);
  const phraseTimerRef = useRef(null);
  const progressRef = useRef(null);

  const clearAll = () => {
    clearTimeout(typingRef.current);
    clearTimeout(phraseTimerRef.current);
    clearInterval(progressRef.current);
  };

  const typePhrase = (text, charIdx = 0, onDone) => {
    if (charIdx > text.length) {
      onDone?.();
      return;
    }
    setDisplayed(text.slice(0, charIdx));
    const delay = TYPING_SPEED + Math.random() * TYPING_JITTER;
    typingRef.current = setTimeout(
      () => typePhrase(text, charIdx + 1, onDone),
      delay
    );
  };

  const startProgress = () => {
    setProgress(0);
    let start = null;
    const duration = PHRASE_DURATION;
    const tick = (ts) => {
      if (!start) start = ts;
      const elapsed = ts - start;
      let prog = Math.min((elapsed / duration) * 100, 100)
      setProgress(prog);
      if (elapsed < duration) {
        progressRef.current = requestAnimationFrame(tick);
      }
    };
    progressRef.current = requestAnimationFrame(tick);
  };

  const showNext = (idx) => {
    clearAll();
    setStatus("entering");
    setDisplayed("");
    setCurrentIndex(idx);

    typePhrase(phrases[idx], 0, () => {
      startProgress();
      const isLast = idx === phrases.length - 1;
      phraseTimerRef.current = setTimeout(() => {
        setStatus("exiting");
        setTimeout(() => {
          const next = isLast ? (loop ? 0 : null) : idx + 1;
          if (next !== null) showNext(next);
          else setStatus("idle");
        }, TRANSITION_DURATION);
      }, PHRASE_DURATION);
    });
  };

  useEffect(() => {
    showNext(0);
    return clearAll;
  }, []);

  return (
    <div style={styles.container}>
      <div style={styles.phraseWrapper}>
        <p
          style={{
            ...styles.phrase,
            opacity: status === "exiting" ? 0 : 1,
            transform:
              status === "entering"
                ? "translateY(10px)"
                : status === "exiting"
                ? "translateY(-10px)"
                : "translateY(0)",
          }}
        >
          {displayed}
          <span style={styles.cursor} />
        </p>
      </div>

    </div>
  );
}

const styles = {
  container: {
    //padding: "2rem 1.5rem",
    width: "90%",
    marginLeft:"5%"
    //fontFamily: "system-ui, -apple-system, sans-serif",
  },
  phraseWrapper: {
    minHeight: "200px",
    //display: "flex",
    alignItems: "center",
    position: "relative",
  },
  phrase: {
    /*fontSize: 22,
    fontWeight: 500,
    lineHeight: 1.4,*/
    margin: 0,
    color: "inherit",
    transition: `opacity ${TRANSITION_DURATION}ms ease, transform ${TRANSITION_DURATION}ms ease`,
  },
  cursor: {
    display: "inline-block",
    width: "4px",
    height: "1.1em",
    background: "#4285F4",
    marginLeft: 3,
    verticalAlign: "text-bottom",
    animation: "blink 0.9s steps(1) infinite",
  },
};
